// @ts-nocheck
/**
 * chat-game.js — Bee runner mini-game shown during arrangement generation.
 *
 * A side-scroller where a bee hops over flowers while Fleur designs.
 * Space (desktop) / tap (mobile) to jump. Score resets on collision.
 *
 * Exposes:
 *   window.AIFlorist.game.start(parentEl)
 *   window.AIFlorist.game.stop()
 */
(function () {
  'use strict';
  window.AIFlorist = window.AIFlorist || {};

  var canvas, ctx, gameEl, animId;
  var isRunning = false;
  var boundKeyDown = null;

  var W = 300, H = 130, GND = 108;
  var GRAV = 0.6, JUMP_VEL = -9.5, BASE_SPD = 2.5, MAX_SPD = 6;

  var bee, obstacles, score, frames, spd;

  function reset() {
    bee = { x: 36, y: GND, vy: 0, jumpsUsed: 0 };
    obstacles = [];
    score = 0;
    frames = 0;
    spd = BASE_SPD;
  }

  function doJump() {
    var onGround = bee.y >= GND - 1;
    if (onGround) {
      bee.vy = JUMP_VEL;
      bee.jumpsUsed = 1;
      return;
    }
    // Allow one extra jump while airborne.
    if (bee.jumpsUsed < 2) {
      bee.vy = JUMP_VEL * 0.92;
      bee.jumpsUsed++;
    }
  }

  // ── Update ──────────────────────────────────────────────────────

  function tick() {
    frames++;
    spd = Math.min(BASE_SPD + Math.floor(score / 5) * 0.3, MAX_SPD);

    bee.vy += GRAV;
    bee.y += bee.vy;
    if (bee.y > GND) { bee.y = GND; bee.vy = 0; bee.jumpsUsed = 0; }

    var gap = Math.max(50, 85 - score * 2);
    if (frames % gap === 0) {
      obstacles.push({
        x: W + 8,
        y: GND - (18 + Math.random() * 14),
        color: Math.random() > 0.5 ? '#E8A0B4' : '#D4A06A',
        passed: false,
      });
    }

    for (var i = obstacles.length - 1; i >= 0; i--) {
      var o = obstacles[i];
      o.x -= spd;
      if (o.x < -24) { obstacles.splice(i, 1); continue; }
      if (!o.passed && o.x + 16 < bee.x) { o.passed = true; score++; }
      if (bee.x + 17 > o.x && bee.x + 5 < o.x + 16 && bee.y + 1 > o.y) {
        reset();
        return;
      }
    }
  }

  // ── Draw ────────────────────────────────────────────────────────

  function drawBee() {
    var x = bee.x, y = bee.y;
    var flap = Math.sin(frames * 0.4) * 3;

    ctx.fillStyle = 'rgba(255,255,255,0.55)';
    ctx.beginPath();
    ctx.ellipse(x + 5, y - 12 + flap, 6, 3.5, -0.3, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.ellipse(x + 14, y - 13 + flap, 6, 3.5, 0.3, 0, Math.PI * 2);
    ctx.fill();

    ctx.fillStyle = '#F5C542';
    ctx.beginPath();
    ctx.ellipse(x + 10, y - 5, 10, 7, 0, 0, Math.PI * 2);
    ctx.fill();

    ctx.strokeStyle = '#6B5000';
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    for (var s = 0; s < 3; s++) {
      var sx = x + 5 + s * 5;
      ctx.moveTo(sx, y - 11);
      ctx.lineTo(sx, y + 1);
    }
    ctx.stroke();

    ctx.fillStyle = '#1A1715';
    ctx.beginPath();
    ctx.arc(x + 18, y - 7, 1.5, 0, Math.PI * 2);
    ctx.fill();
  }

  function drawFlower(o) {
    var cx = o.x + 8, cy = o.y + 8;

    ctx.strokeStyle = '#6B9E7E';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(cx, cy + 5);
    ctx.lineTo(cx, GND + 4);
    ctx.stroke();

    ctx.fillStyle = o.color;
    for (var p = 0; p < 5; p++) {
      var a = (p / 5) * Math.PI * 2 - Math.PI / 2;
      ctx.beginPath();
      ctx.arc(cx + Math.cos(a) * 5.5, cy + Math.sin(a) * 5.5, 4, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.fillStyle = '#F5C542';
    ctx.beginPath();
    ctx.arc(cx, cy, 3, 0, Math.PI * 2);
    ctx.fill();
  }

  function draw() {
    ctx.clearRect(0, 0, W, H);

    ctx.strokeStyle = '#DDD6CE';
    ctx.lineWidth = 1;
    ctx.setLineDash([4, 4]);
    ctx.beginPath();
    ctx.moveTo(0, GND + 4);
    ctx.lineTo(W, GND + 4);
    ctx.stroke();
    ctx.setLineDash([]);

    for (var i = 0; i < obstacles.length; i++) drawFlower(obstacles[i]);
    drawBee();

    ctx.fillStyle = '#8A8480';
    ctx.font = '600 11px Inter, system-ui, sans-serif';
    ctx.textAlign = 'right';
    ctx.fillText(score, W - 8, 14);
  }

  // ── Loop ────────────────────────────────────────────────────────

  function loop() {
    if (!isRunning) return;
    tick();
    draw();
    animId = requestAnimationFrame(loop);
  }

  // ── Public API ──────────────────────────────────────────────────

  function start(parentEl) {
    if (isRunning) stop();

    gameEl = document.createElement('div');
    gameEl.className = 'afc-msg afc-msg--assistant afc-game-wrap';

    var card = document.createElement('div');
    card.className = 'afc-game';

    canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    canvas.className = 'afc-game-canvas';
    card.appendChild(canvas);

    var hint = document.createElement('div');
    hint.className = 'afc-game-hint';
    var mobile = window.matchMedia('(pointer: coarse)').matches || window.innerWidth <= 768;
    hint.textContent = mobile
      ? 'Tap (or double-tap) to jump!'
      : 'Press Space (double-space for double jump)!';
    card.appendChild(hint);

    gameEl.appendChild(card);
    parentEl.appendChild(gameEl);
    parentEl.scrollTop = parentEl.scrollHeight;

    ctx = canvas.getContext('2d');
    reset();

    boundKeyDown = function (e) {
      if ((e.code === 'Space' || e.key === ' ') && !e.repeat) {
        e.preventDefault();
        doJump();
      }
    };
    document.addEventListener('keydown', boundKeyDown);
    card.addEventListener('touchstart', function (e) {
      e.preventDefault();
      doJump();
    }, { passive: false });
    card.addEventListener('click', doJump);

    isRunning = true;
    loop();
  }

  function stop() {
    isRunning = false;
    if (animId) { cancelAnimationFrame(animId); animId = null; }
    if (boundKeyDown) {
      document.removeEventListener('keydown', boundKeyDown);
      boundKeyDown = null;
    }
    if (gameEl) { gameEl.remove(); gameEl = null; }
    canvas = null;
    ctx = null;
  }

  window.AIFlorist.game = { start: start, stop: stop };
})();
